import { Node } from 'slate';
import type { ReactNode } from 'react';
import { isEmojiOnlyMessage } from '@halo/chat-sdk';
import type {
  DeserializePayloadStringHandlerOptions,
  SerializePayloadHandlerOptions,
} from '../../serialize/serialize';
import { SerializePayloadHandler } from '../../serialize/serialize';
import { codesToEmoji, matchOnlyEmojis } from './utils';
import { OriginalRender, LottieRender } from './components/emoji-render';

export class SerializePayloadHandler_emoji extends SerializePayloadHandler {
  serialize({ entry: [node], context, payload }: SerializePayloadHandlerOptions) {
    if (!context.notOnlyEmojis) {
      const text = Node.string(node);
      const codes = matchOnlyEmojis(text);
      if (codes) {
        payload.emojiOnlyCount = (payload.emojiOnlyCount || 0) + codes.length;
      } else {
        context.notOnlyEmojis = true;
        payload.emojiOnlyCount = 0;
      }
    }
  }

  deserializeString({
    key,
    text,
    payload,
    props,
  }: DeserializePayloadStringHandlerOptions<{
    preview?: boolean;
    getData?: (id: string) => Promise<object | undefined>;
  }>) {
    let children: ReactNode;

    if (!props.preview) {
      if (payload.emojiOnlyCount === 1 && props.getData) {
        const codesList = matchOnlyEmojis(text);
        if (codesList) {
          const codes = codesList[0];
          const id = codes.join('_');
          children = (
            <LottieRender
              key={key}
              size={140}
              emoji={codesToEmoji(codes)}
              getData={() => props.getData!(id)}
              lottieOptions={{
                autoplay: true,
                loop: true,
              }}
            ></LottieRender>
          );
        }
      } else if (isEmojiOnlyMessage({ payload })) {
        children = (
          <OriginalRender key={key} size={30 * (6 / payload.emojiOnlyCount)}>
            {text}
          </OriginalRender>
        );
      }

      if (children) {
        return {
          children,
        };
      }
    }
  }
}
